import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=a61d2e40&scoped=true&lang=pug&"
import script from "./Messaging.vue?vue&type=script&lang=ts&"
export * from "./Messaging.vue?vue&type=script&lang=ts&"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=a61d2e40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61d2e40",
  null
  
)

export default component.exports